import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { Notice, Separator } from 'telia-front-react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { getIsDealerFromAuth } from '../util/InternetCalculatorUtil';
import { useInternetNotices } from '../InternetNoticesProvider';
export const RepresentationStipulationNotice = () => {
    const translate = React.useContext(TranslationsContext).translate;
    const { representationStipulationState } = useInternetNotices();
    const { auth } = useInternetCalculator();
    const isDealer = getIsDealerFromAuth(auth);
    return (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "xsmall", color: "invisible" }),
        React.createElement(Notice, { type: isDealer ? 'employee' : 'error', align: "center" }, translate(`secureNetCalculator.${isDealer ? 'dealer.' : ''}representationStipulationNotice`, {
            stipulation: representationStipulationState.stipulation
        }))));
};
